<template>
    <section class="py-16 bg-gradient-to-br pt-44 from-green-400 to-green-500">
      <div class="container mx-auto px-4">
        <h2 class="text-4xl font-bold text-center mb-12 text-white">{{ t('feedback.title') }}</h2>
        <div class="relative overflow-hidden">
          <div 
            class="flex transition-transform duration-500 ease-in-out"
            :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
          >
            <div 
              v-for="feedback in feedbacks" 
              :key="feedback.id"
              class="w-full flex-shrink-0 px-4"
            >
              <div v-if="feedback" class="bg-white rounded-lg shadow-lg overflow-hidden w-full max-w-md mx-auto">
                <div class="p-8">
                  <!-- Profile Image Section -->
                  <div class="flex items-center justify-center mb-6">
                    <img 
                      :src="feedback.image || 'https://random-image-pepebigotes.vercel.app/random-image'" 
                      :alt="`Profile of ${feedback.name}`" 
                      class="w-16 h-16 rounded-full object-cover mr-4" 
                    />
                    <component :is="feedback.icon || UserIcon" class="w-8 h-8 text-green-500" />
                  </div>
                  <h3 class="text-2xl font-semibold mb-4 text-center text-gray-800">{{ feedback.name }}</h3>
                  <p class="text-gray-600 text-center">{{ feedback.comment }}</p>
  
                  <div class="text-center mt-4">
                    <div class="flex justify-center">
                      <!-- Star Rating -->
                      <div 
                        v-for="star in 5" 
                        :key="star" 
                        :class="star <= (feedback.number_of_stars || 0) ? 'text-yellow-500' : 'text-gray-300'" 
                        class="w-12 h-12 flex items-center justify-center text-4xl"
                      >
                        ★
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="bg-gray-50 px-8 py-4">
                  <button 
                    @click="openModal"
                    class="w-full py-2 px-4 bg-green-500 hover:bg-green-600 text-white rounded transition-colors duration-300"
                  >
                    {{ t('feedback.addComment') }}
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Navigation Buttons -->
        <div class="flex justify-center mt-8 space-x-2">
          <button 
            v-for="(_, index) in feedbacks" 
            :key="index"
            @click="setCurrentIndex(index)"
            class="w-3 h-3 rounded-full transition-all duration-300 focus:outline-none"
            :class="currentIndex === index ? 'bg-green-500 scale-125' : 'bg-gray-300 hover:bg-gray-400'"
          ></button>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { computed, ref, onMounted } from 'vue';
  import { useDataStore } from '@/stores/mainStore';
  import { useI18n } from 'vue-i18n';
  
  const store = useDataStore();
  const { t } = useI18n();
  
  // Directly use the feedback.comment from the API
  const feedbacks = computed(() => store.data.feedbacks);
  
  const currentIndex = ref(0); // Define currentIndex as a reactive variable
  
  const setCurrentIndex = (index) => {
    currentIndex.value = index; // Update the currentIndex when the button is clicked
  };
  
  onMounted(() => {
    store.fetchData();
  });
  </script>
  
  <style scoped>
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .bg-white {
    animation: fadeIn 0.5s ease-out;
  }
  
  .w-full {
    width: 100%;
  }
  
  .max-w-md {
    max-width: 500px;
  }
  
  .w-12 {
    width: 3rem; /* Larger size for the stars */
    height: 3rem; /* Larger size for the stars */
  }
  
  .text-4xl {
    font-size: 2.25rem; /* Large font size for stars */
  }
  
  .text-yellow-500 {
    color: #f59e0b; /* Yellow color */
  }
  
  .text-gray-300 {
    color: #d1d5db; /* Gray color */
  }
  
  /* Optional: Add some hover effect on the stars */
  .w-12:hover {
    transform: scale(1.2);
    transition: transform 0.3s ease-in-out;
  }
  </style>
  